<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-faq') }}
            <div class="card-header-actions">
              <router-link to="/content/faq" class="card-header-action btn-setting">
                <buttons button-type="back" />
              </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveData">
            <b-row>
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <template v-for="lang in langArr">
                      <tr>
                        <th colspan="2">
                          <h4>{{ $t('str.'+lang) }}</h4>
                        </th>
                      </tr>
                      <tr>
                        <th scope="row">{{$t('str.question')}}</th>
                        <td>
                          <template v-if="lang === 'en'">
                            <b-form-input type="text" name="question"
                              :class="{ 'form-control': true, 'is-invalid': errors.has('question') }" id="question"
                              v-validate="{ required: true }" v-model="addData['question_'+lang]" />
                            <span class="invalid-feedback">{{ errors.first('question') }}</span>
                          </template>
                          <template v-else>
                            <b-form-input type="text" :name="'question_'+lang" :id="'question_'+lang"
                              :class="{ 'form-control': true, 'rtl': lang == 'ar' || lang == 'fa' }"
                              v-model="addData['question_'+lang]" />
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">{{$t('str.answer')}}</th>
                        <td>
                          <template v-if="lang === 'en'">
                            <quill-editor v-model="addData['answer_'+lang]" ref="answer" @blur="onEditorBlur($event)"
                              @focus="onEditorFocus($event)" @ready="onEditorReady($event)">
                            </quill-editor>
                            <span class="invalid-feedback">{{ errors.first('answer') }}</span>
                          </template>
                          <template v-else>
                            <quill-editor v-model="addData['answer_'+lang]" :ref="'answer_'+lang"
                              @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                              @ready="onEditorReady($event)">
                            </quill-editor>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import Buttons from '@/views/component/Buttons'

import * as Auth from '@/shared/auth'
import * as helper from '@/shared/helper'

const envi = process.env

export default {
  components: {
    'buttons': Buttons
  },
  data() {
    return {
      id: this.$route.params.id,
      langArr: envi.VUE_APP_LANG.split(','),
      addData: {
        question_en: '',
        question_zh: '',
        question_bn: '',
        question_ms: '',
        question_my: '',
        question_th: '',
        question_tl: '',
        question_vi: '',
        question_ar: '',
        question_es: '',
        question_ja: '',
        question_hi: '',
        question_fr: '',
        question_pt: '',
        question_fa: '',
        answer_en: '',
        answer_zh: '',
        answer_bn: '',
        answer_ms: '',
        answer_my: '',
        answer_th: '',
        answer_tl: '',
        answer_vi: '',
        answer_ar: '',
        answer_es: '',
        answer_ja: '',
        answer_hi: '',
        answer_fr: '',
        answer_pt: '',
        answer_fa: ''
      }
    }
  },
  methods: {
    async getData() {
      this.$auth.checkSession()
      var faqId = this.id

      if (faqId > 0) {
        try {
          var getData = await axios.get(`${envi.VUE_APP_API_URL}/Faq/${faqId}`, {
            headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
          })

          for (let i = 0; i < this.langArr.length; i++) {
            this.addData['question_' + this.langArr[i]] = getData.data.data['question_' + this.langArr[i]]
            this.addData['answer_' + this.langArr[i]] = getData.data.data['answer_' + this.langArr[i]]
          }
        } catch (e) {
          console.log('err', e.response)
          if (e.response) {
            this.$router.push('/pages/404')
          }
        }
      }
    },
    async saveData() {
      this.$auth.checkSession()
      if (this.$validator.validateAll()) {
        var method = 'post'
        var url = `${envi.VUE_APP_API_URL}/Faq/`
        if (this.id > 0) {
          method = 'patch'
          url = `${url}${this.id}`
        }

        try {
          var result = await axios[method](url, this.addData, {
            headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
          })

          this.$toast.success(result.data.meta.message, '', {
            position: 'topCenter'
          })
          // this.$router.push('/content/faq')
        } catch (e) {
          if (Array.isArray(e.response.data.meta.error)) {
            e.response.data.meta.error.forEach((err) => {
              this.$toast.error(err.msg, e.response.data.meta.message, {
                position: 'topCenter'
              })
            })
          } else if (typeof e.response.data.meta.error === 'string') {
            this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
              position: 'topCenter'
            })
          }
        }
      }
    }
  },
  created() {
    this.getData()
  }
}
</script>